import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { IconTypes } from 'src/types';

/**
 * @internal
 */
export type MoveToNextStageProps = SvgIconProps;

/**
 * @internal
 */
export const MoveToNextStage: FC<MoveToNextStageProps> = props => (
  <SvgIcon aria-label={IconTypes.MOVE_TO_NEXT_STAGE} {...props}>
    <>
      <g id="fx-T-pMb9gGf_Hmsm7gTK" transform="matrix(1.44 0 0 1.44 19.66 15.59)">
        <path
          d="M 16 10 L 11 10 L 11 12 L 16 12 L 16 10 Z"
          strokeLinecap="round"
          transform=" translate(-13.5, -11)"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <g id="k0-TMDgvzb5zA7Vhutb-q" transform="matrix(1.44 0 0 1.44 6.73 12)">
        <path
          d="M 5 4 L 9 4 L 9 2 L 5 2 C 2.243 2 0 4.243 0 7 C 0 9.757 2.243 12 5 12 L 5 15 L 9 11 L 5 7 L 5 10 C 3.346 10 2 8.654 2 7 C 2 5.346 3.346 4 5 4 Z"
          strokeLinecap="round"
          transform=" translate(-4.5, -8.5)"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <g id="d2rQPr5Rz0FncT5bzy6Rd" transform="matrix(1.44 0 0 1.44 19.66 4.1)">
        <path
          d="M 16 2 L 11 2 L 11 4 L 16 4 L 16 2 Z"
          strokeLinecap="round"
          transform=" translate(-13.5, -3)"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </>
  </SvgIcon>
);
